export default {
  waiting: 'Programado',
  searching: 'Buscando repartidor',
  active: 'Activa',
  done: 'Completada',
  cancelled: 'Cancelada'
}
